import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import tabsModule from "./store/tabs";
import { TabsState } from "./store/tabs";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as Icons from "@element-plus/icons";
import "./styles/index.scss"
store.registerModule('tabs', tabsModule);

store.subscribe((mutation, state: any) => {
  if (mutation.type.startsWith('tabs/')) {
    const tabsState = state.tabs as TabsState;
    if (tabsState) {
      sessionStorage.setItem('tabs', JSON.stringify(tabsState));
    }
  }
});
const app = createApp(App);
app.use(ElementPlus);
app.use(store);
app.use(router);
app.mount("#app");
const computedHeight = (argArr: any) => {
  let totalHeight = 0;
  for (let i = 0; i < argArr.length; i++) {
    if (document.getElementsByClassName(argArr[i])[0]) {
      totalHeight += document.getElementsByClassName(argArr[i])[0].clientHeight;
    }
  }
  return totalHeight;
};
app.config.globalProperties.$doResize = function (tab: any) {
  const height = computedHeight(["componentHeade", "operationCont", "paginationCont"]);
  const dom = <HTMLElement>document.getElementsByClassName(tab + "-table")[0];
  if (dom) {
    dom.style.height = window.innerHeight - (height + 70) + "px";
  }
};
Object.keys(Icons).forEach((key) => {
  app.component(key, Icons[key as keyof typeof Icons]);
});
